<template>
    <div>
        <div class="mainTitle text-center my-3">
            <h3>{{$t('tradeToolbox')}}</h3>
        </div>
        <div class="maxContainer border traderBox whiteBG radius px-md-4 py-md-4 py-xs-3 mb-3">
        	<div class="row justify-content-center">
        	 <div class="col-12 col-md-10 midMob">	
	        	<div class="row align-items-center">
					<div class="col-12 col-md-6 text-center">
						<div class="mb-2">
							<img src="../../../../static/fxView/images/boxTool-2.svg" alt="Email Support" class="mtImg-svg">
						</div> 
						<div class="downloadBox-tool mb-0">
						 	<h5 class="m-0">
						 		<a href="https://fxview.com/trader-tool-box" class="btn_xs grd_btn clk" target="_blank">{{$t('moreAboutTradeToolbox')}}  </a>
						 	</h5>
						</div>
					</div>
				    <div class="col-12 col-md-6">
					<p>{{$t('tradeToolMsz1')}}</p>
					<p>{{$t('tradeToolMsz2')}}</p> 
					<div class="text-center">
						<div class="mt-4 d-flex flex-wrap align-item-center justify-content-start"> 
							<a href="https://www.fxbluelabs.com/downloads/fxview/FXView-MT4-Apps.20200724.zip" class="prism_btn darkBG btn_sm mr-md-3 mb-3">{{$t('DownloadMT4')}} </a>
							<!-- <a href="https://www.fxbluelabs.com/downloads/fxview/FXView-MT5-Apps.20200724.zip" class="prism_btn secndrybtn btn_sm  mr-md-3 mb-3">{{$t('DownloadMT5')}} </a>  -->
						</div>
						<a href="#" class="prism_btn btn_sm mr-md-3" style="position: relative; left: -80px;">Subscribe for Live Account </a>
					</div>
				  </div>
			     </div>
			  </div>
	  	    </div>
	  	</div>
	  	<div class="maxContainer">
			<div class="mainTitle text-center mt-4 mb-3"><h3>{{$t('WhatYouGet')}}</h3></div>
			<div class="border traderBox whiteBG radius px-md-4 py-md-4 py-xs-3 mb-3">
			<div class="row">
				<div class="col-12 col-lg-6"> 
				  	<h5 class="mb-3 text-center">{{$t('TraderToolboxApp')}}</h5>
						  <ul class="listing toolBox-app d-flex flex-wrap">
						    <li>{{$t('TradeTerminal')}}</li>
						    <li>{{$t('MiniTerminal')}} </li>
						    <li>{{$t('AlarmsManager')}} </li>
						    <li>{{$t('ExcelRTD')}}</li>
						    <li>{{$t('Connect')}} </li>
						    <li>{{$t('SentimentTrader')}}</li>
						    <li>{{$t('SessionMap')}} </li>
						    <li>{{$t('MarketManager')}} </li>
						    <li>{{$t('CorrelationMatrix')}}</li>
						    <li>{{$t('CorrelationTrader')}}</li>
						    <li>{{$t('TickTrader')}}</li>
						    <li>{{$t('StealthOrder')}}</li>
						    
						  </ul>
				</div>
				<div class="col-12 col-lg-6 mobTop"> 
			  		<h5 class="mb-3 text-center">{{$t('IndicatorPackage')}}</h5>
							  <ul class="listing toolBox-app d-flex flex-wrap">
							    <li>{{$t('Minichart')}}</li>
							    <li>{{$t('PivotPoints')}}</li>
							    <li>{{$t('HighsLows')}}</li>
								<li>{{$t('Renkobars')}}</li>
								<li>{{$t('ChartGroup')}}</li>
								<li>{{$t('SymbolInfo')}}</li>
								<li>{{$t('Gravity')}}</li>
								<li>{{$t('Chart_in_Chart')}}</li>
								<li>{{$t('PeriodConverter')}}</li>
								<li>{{$t('Magnifier')}}</li>
								<li>{{$t('OrderHistory')}}</li>
								<li>{{$t('FreehandDrawing')}}</li>
								<li>{{$t('BarChanger')}}</li>
								<li>{{$t('KeltnerChannel')}}</li>
								<li>{{$t('DonchianChannel')}}</li>
								<li>{{$t('CandleCountdown')}}</li>
								<li>{{$t('LinearRegression')}}</li>
							  </ul>
				</div>
			</div>
		 </div>
		</div>
		<div class="maxContainer border traderBox whiteBG radius px-md-4 py-md-4 py-xs-3 mb-3"> 
			<div class="downloadT">
				<h5 class="mb-1">{{$t('howToUse')}}</h5>
				<!-- <p>{{$t('useTraderToolbox')}}</p> -->
				<!-- <p class="m-0">{{$t('HowInstallTraderToolbox')}}</p> -->
				<div class="row">
				<div class="col-12 col-md-6">		
				<ul class="listing py-3 px-1">
				    <li> {{$t('loginFxViewmt45')}}</li>
				    <li>{{$t('ToolboxApplication')}}</li>
				    <li>{{$t('FxviewMT45installation')}}</li>
				    <li>{{$t('allowDdlImports')}}</li>
				    <li>{{$t('RestartFxviewMT45')}}</li>
				  </ul>
				</div> 
			   </div>
			</div>
		</div>
		<div class="maxContainer border step-bottom-alert mb-5 whiteBG text-center justify-content-center">
			<span class="position-relative l-0"><feather type="alert-circle"></feather></span> 
			<p class="ml-2">{{$t('tradeToolboxliveMinDeposit')}} </p>
		</div>
		<div class="mb-2 text-center disclaimer darkBG p-3 row d-flex justify-content-center align-items-center">
			<div class="col-12 col-md-10">
				<small>{{$t('DisclaimerAutoChartist')}}</small>
			</div>
		</div>
    </div>
</template>
<script> 
	import { fxViewMixins } from '@/plugins/fxView'
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	export default {
		name: 'Signal-Centre',
		mixins: [fxViewMixins],
		data() {
			return {
				//===========prop in loader component=======
				col_span : 5,
				load_more_msz : false,
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				loaderFuncRun : '1',
				//==========================================
				pageLimit : '15',
				search : '',
				page : 1
			}
		},
		methods:{
			loadList(){
				this.page = parseInt(this.page) + 1
				this.listing()
			},
			listing(){
				let inputJson = {
					'globalParams' : {
						filter: {},
						sort: [],
						search: this.search,
						page: this.page,
						perPage: parseInt(this.pageLimit),
					} ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
				}
				this._runGetSignalCentreData(inputJson)
			}
		},
		created(){
			if(this.$store.getters[Const.GET_SIGNAL_CENTRE] != ''){
				this.loaderFuncRun = '0'
			}
			this.listing()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/tradertool_box.vue